import { FormHelp } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';

const helperTextClass = css({ flex: 1 });
const counterClass = css({
  whiteSpace: 'nowrap',
  flexShrink: 0,
  marginLeft: 'auto',
  paddingLeft: 'tighter',
});

type CharacterCountHelpProps = {
  currentLength: number;
  maxLength: number;
  isFocused: boolean;
  label: string;
  helperText?: string;
  errorText?: string;
};

export default function CharacterCountHelp({
  currentLength,
  maxLength,
  isFocused,
  label = 'Text',
  helperText = '',
  errorText,
}: CharacterCountHelpProps) {
  const isOverLimit = currentLength > maxLength;
  const showCounter = isFocused || isOverLimit;
  const formattedMax = maxLength.toLocaleString();
  const resolvedErrorText = errorText ?? `${label} must be ${formattedMax} characters or fewer`;

  return (
    <FormHelp css={showCounter ? { display: 'flex' } : undefined}>
      <span className={helperTextClass}>{isOverLimit ? resolvedErrorText : helperText}</span>
      {showCounter && (
        <span className={counterClass}>
          {currentLength.toLocaleString()}/{formattedMax} characters
        </span>
      )}
    </FormHelp>
  );
}
